/**
 * WorkshopPickerList — the grouped-by-month list view of {@link WorkshopPicker}
 * (design 02 mobile). Pure presentational: renders the already-filtered
 * workshops in the order they arrived; selecting a row lifts the id.
 */
import type { PickerWorkshop } from './pickerWorkshop';
import { groupByMonth } from './WorkshopPickerHelpers';
import { WorkshopPickerListRow } from './WorkshopPickerListRow';

export interface WorkshopPickerListProps {
  workshops: PickerWorkshop[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function WorkshopPickerList({ workshops, selectedId, onSelect }: WorkshopPickerListProps) {
  const groups = groupByMonth(workshops);
  return (
    <div role="listbox" aria-label="Workshops" className="space-y-5">
      {groups.map((group) => (
        <div key={group.key}>
          <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-stone-400">
            {group.label}
          </p>
          <div className="space-y-2">
            {group.workshops.map((w) => (
              <WorkshopPickerListRow
                key={w.id}
                workshop={w}
                selected={selectedId === w.id}
                onSelect={onSelect}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
